import { createRecipe } from './runtime.js';

const textColorConfig = {"name":"textColor"}

export const textColor = /* @__PURE__ */ createRecipe(textColorConfig)